import { fetch, post } from '@/utils/axios'

export default {
  // 获取K线
  getKlines: (params) => {
    return fetch('/base/kline/list', params)
  },

  // 获取单个k线数据
  getKline: (params) => {
    return fetch('/base/kline/one', params)
  }
}